export default "__VITE_ASSET__BYsWOH0q__"